<script setup>
import { computed } from 'vue'
import { useNotificationStore } from '../stores/notificationStore'

const props = defineProps({
  collapsed: { type: Boolean, default: true },
  unread: { type: Number, default: 0 },
})

const emit = defineEmits(['open-notifications'])

const notificationStore = useNotificationStore()

// Get SSE connection status
const sseConnected = computed(() => notificationStore.isSSEConnected)

const handleClick = () => {
  emit('open-notifications')
}
</script>

<template>
  <div class="w-full">
    <!-- Collapsed: simple round button, consistent with search button area -->
    <button
      v-if="collapsed"
      @click="handleClick"
      class="w-full flex flex-col items-center justify-center px-0 py-2 text-gray-700 hover:bg-gray-100 border-b border-gray-200 transition-colors relative"
      :title="`Notifications ${sseConnected ? '(Live)' : '(Offline)'}`"
    >
      <i class="fas fa-bell text-xl mb-1"></i>
      <div class="flex items-center text-[8px] text-gray-400 leading-tight">
        <span>EVENTS</span>
      </div>
      <!-- SSE Connection Status Indicator -->
      <!-- <div 
        class="absolute top-1 left-2 w-2 h-2 rounded-full"
        :class="sseConnected ? 'bg-green-500' : 'bg-red-500'"
        :title="sseConnected ? 'Live notifications' : 'Notifications offline'"
      ></div> -->
      <!-- Unread Count Badge -->
      <!-- <div v-if="unread > 0" class="absolute top-1 right-2 min-w-[18px] h-[18px] bg-pink-500 text-white rounded-full text-[10px] flex items-center justify-center px-1">
        {{ unread }}
      </div> -->
    </button>

    <!-- Expanded: row with label -->
    <button
      v-else
      @click="handleClick"
      class="hidden w-full flex flex-row items-center px-4 py-2 gap-2 text-gray-700 hover:bg-gray-100 border-b border-gray-200 transition-colors"
      :title="`Notifications ${sseConnected ? '(Live)' : '(Offline)'}`"
    >
      <i class="fas fa-bell text-sm"></i>
      <span class="ml-2 font-medium text-sm">Events</span>
      <!-- SSE Connection Status Indicator -->
      <div 
        class="ml-auto w-2 h-2 rounded-full mr-2"
        :class="sseConnected ? 'bg-green-500' : 'bg-red-500'"
        :title="sseConnected ? 'Live' : 'Offline'"
      ></div>
      <!-- Unread Count Badge -->
      <span v-if="unread > 0" class="text-[10px] text-white bg-pink-500 px-1.5 py-0.5 rounded-full">{{ unread }}</span>
    </button>
  </div>
</template>

<style scoped>
</style>


